import { Drums } from '@ezchops/drums';
import { KeyboardDrumAdapter, MidiDrum } from '@ezchops/drums/lib/adapter';
import React, { useEffect, useMemo, useState } from 'react';
import { useMIDIContext } from './MIDIContext';
export const DrumContext = React.createContext(null);
export function useDrumContext() {
    const context = React.useContext(DrumContext);
    if (context == null) {
        throw new Error('DrumContext is not set');
    }
    return context;
}
export function DrumContextProvider({ findConfig, children }) {
    const midiContext = useMIDIContext();
    const [selectedId, setSelectedId] = useState(null);
    const selectedInput = useMemo(() => {
        if (selectedId != null) {
            return midiContext.inputs.get(selectedId);
        }
    }, [midiContext.inputs, selectedId]);
    useEffect(() => {
        if (selectedId == null && midiContext.inputs.size > 0) {
            setSelectedId((id) => id ?? midiContext.inputs.keys().next().value);
        }
    }, [midiContext.inputs, selectedId, setSelectedId]);
    const [drum, setDrum] = useState(null);
    useEffect(() => {
        if (selectedInput != null) {
            findConfig(selectedInput).then(config => setDrum(new MidiDrum(selectedInput, config)));
        }
        else {
            setDrum(null);
        }
        return () => {
        };
    }, [findConfig, selectedInput]);
    const context = {
        selectedInput: selectedInput ?? null,
        selectInput: setSelectedId,
        drum
    };
    return React.createElement(DrumContext.Provider, { value: context }, children);
}
export function useDrumAdapter(clock) {
    const [adapter, setAdapter] = useState(null);
    const { drum } = useDrumContext();
    const keyMapping = useMemo(() => ({
        'a': Drums.KICK,
        's': Drums.SNARE,
        'd': Drums.HI_TOM,
        'f': Drums.MID_TOM,
        'g': Drums.LOW_TOM,
        'h': Drums.CRASH,
        'j': Drums.RIDE,
        'k': Drums.CLOSED_HI_HAT,
        'l': Drums.OPEN_HI_HAT,
        '.': Drums.PEDAL_HI_HAT
    }), []);
    useEffect(() => {
        if (drum != null) {
            const adapter = drum.createAdapter(clock);
            setAdapter(adapter);
            return () => {
                adapter.close();
            };
        }
        else {
            const adapter = new KeyboardDrumAdapter(clock, keyMapping);
            setAdapter(adapter);
            return () => {
                adapter.close();
            };
        }
    }, [clock, drum, keyMapping]);
    return adapter;
}
//# sourceMappingURL=DrumContext.js.map